import React from "react";
import "./index.css";
import soft1 from "../../assets/11.jpg";
import soft2 from "../../assets/12.jpg";
import soft3 from "../../assets/13.jpg";
import soft4 from "../../assets/14.jpg";
import soft5 from "../../assets/中网智慧设备追踪管控系统.jpg";
import soft6 from "../../assets/中网智慧数据动态滚动.jpg";
import soft7 from "../../assets/中网智慧物联工厂数据图表软件.jpg";
import soft8 from "../../assets/中网智慧物联设备智能预警软件.jpg";
import soft9 from "../../assets/中网智慧信息识别服务软件.jpg";
import soft10 from "../../assets/中网智慧自动化控制技术管理平台.jpg";

export default function Announcement() {
  return (
    <div>
      <div className="job">
        <h2>获得证书</h2>
        <div className="xian"></div>
        <div className="en">Certificate</div>
        <ul>
          <li>
            <div>
              <img src={soft1} alt="" />
            </div>
            <div>中网智慧工业智慧园区信息监管系统</div>
          </li>
          <li>
            <div>
              <img src={soft2} alt="" />
            </div>
            <div>中网智慧基于网络安全的大数据安全分析管理平台</div>
          </li>
          <li>
            <div>
              <img src={soft3} alt="" />
            </div>
            <div>中网智慧工业生产智慧看板系统</div>
          </li>
          <li>
            <div>
              <img src={soft4} alt="" />
            </div>
            <div>中网智慧生产可视化安全监控平台</div>
          </li>
        </ul>
        <ul>
          <li>
            <div>
              <img src={soft5} alt="" />
            </div>
            <div>中网智慧设备追踪管控系统</div>
          </li>
          <li>
            <div>
              <img src={soft6} alt="" />
            </div>
            <div>中网智慧数据动态滚动</div>
          </li>
          <li>
            <div>
              <img src={soft7} alt="" />
            </div>
            <div>中网智慧物联工厂数据图表软件</div>
          </li>
          <li>
            <div>
              <img src={soft8} alt="" />
            </div>
            <div>中网智慧物联设备智能预警软件</div>
          </li>
        </ul>
        <ul>
          <li>
            <div>
              <img src={soft9} alt="" />
            </div>
            <div>中网智慧信息识别服务软件</div>
          </li>
          <li>
            <div>
              <img src={soft10} alt="" />
            </div>
            <div>中网智慧自动化控制技术管理平台</div>
          </li>
        </ul>

      </div>
    </div>
  );
}
